import { types as t, Instance } from 'mobx-state-tree';
import BaseConfiguration from './base';

const AeccCategoryModel = t.model('AeccCategory', {
  group: t.string,
  node_ids: t.array(t.string),
  subcategories: t.array(t.string)
});

const Cms2567ReportModel = t.compose(
  t.model({
    aecc_categories: t.array(AeccCategoryModel),
    view: t.maybeNull(t.optional(t.enumeration('View', ['basic', 'extended']), 'basic')),
    standard: t.optional(t.enumeration('Standard', ['airthinx-cms-2567']), 'airthinx-cms-2567')
  }),
  BaseConfiguration
);

export interface ICms2567ReportModel extends Instance<typeof Cms2567ReportModel> {}
export interface IAeccCategoryModel extends Instance<typeof AeccCategoryModel> {}

export default Cms2567ReportModel;
